import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'moment/locale/pt-br';
import { Link } from 'react-router-dom';
import SweetAlert from 'react-bootstrap-sweetalert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faCalendarAlt, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import api from '../../services/api';

import { ButtonPanel, ManagerList } from './styles';

import Button from '../../components/Button';
import DropdownButton from '../../components/DropdownButton';
import Input from '../../components/Input';
import Loading from '../../components/Loading';

export default class EventDetail extends Component {
  state = {
    alert: {},
    event: {},
    loading: true,
    showAlert: false,
  };

  static propTypes = {
    match: PropTypes.shape().isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
  };

  roleTranslation = {
    owner: 'Criador',
    admin: 'Administrador',
    manager: 'Gerente',
  };

  componentDidMount() {
    this.loadEvent();
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  loadEvent = async () => {
    try {
      const { id } = this.props.match.params;
      const { data } = await api.get(`events/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });

      data.event.producers = data.event.producers.map(producer => ({
        ...producer,
        translated_role: this.roleTranslation[producer.role],
      }));
      data.event.finishable = Date.parse(data.event.end_at) < Date.now();
      data.event.start_at = moment(data.event.start_at).format('D [de] MMMM [de] YYYY, HH:mm[h]');
      data.event.end_at = moment(data.event.end_at).format('D [de] MMMM [de] YYYY, HH:mm[h]');
      data.event.last_post_date = data.event.last_post_date
        ? moment(data.event.last_post_date).format('D [de] MMMM [de] YYYY, HH:mm[h]')
        : null;

      this.setState({ event: data.event });

      if (data.event.status === 'pending_evaluation') {
        this.setState(
          {
            alert: {
              title: 'Atenção',
              type: 'warning',
              messages: [
                'Os divulgadores ainda não foram avaliados. Avalie para visualizar as informações do evento.',
              ],
              onConfirm: () => this.props.history.push(`/panel/events/${id}/evaluate`),
            },
          },
          () => {
            this.openAlert();
          },
        );
      }

      this.setState({ loading: false });
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: [
              'Não foi possível carregar o evento. Por favor, atualize a página e tente novamente.',
            ],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  openAlert = () => {
    this.setState({
      showAlert: true,
    });
  };

  closeAlert = () => {
    this.setState({
      showAlert: false,
    });
  };

  deleteEvent = (id) => {
    this.setState(
      {
        alert: {
          title: 'Tem certeza que deseja deletar o evento?',
          type: 'warning',
          messages: [
            'Todas as informações serão apagadas permanentemente e o evento não aparecerá em seu histórico.',
          ],
          confirmBtnText: 'Deletar',
          confirmBtnBsStyle: 'danger',
          showCancel: true,
          cancelBtnText: 'Não',
          cancelBtnBsStyle: 'info',
          onConfirm: () => this.confirmDeleteEvent(id),
        },
      },
      () => {
        this.openAlert();
      },
    );
  };

  confirmDeleteEvent = async (id) => {
    try {
      await api.delete(`events/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });

      this.closeAlert();
      this.props.history.push('/panel');
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: ['Apenas administradores podem deletar este evento.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  finishEvent = (id) => {
    this.setState(
      {
        alert: {
          title: 'Deseja finalizar o evento e avaliar os divulgadores?',
          type: 'warning',
          messages: ['O evento será salvo em seu histórico e não poderá mais ser editado.'],
          confirmBtnText: 'Finalizar',
          confirmBtnBsStyle: 'warning',
          showCancel: true,
          cancelBtnText: 'Não',
          cancelBtnBsStyle: 'info',
          onConfirm: () => this.confirmFinishEvent(id),
        },
      },
      () => {
        this.openAlert();
      },
    );
  };

  confirmFinishEvent = async (id) => {
    try {
      const { data } = await api.put(`events/${id}/finish`, null, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });

      if (data.event.status === 'pending_evaluation') {
        this.props.history.push(`/panel/events/${id}/evaluate`);
      }

      data.event.producers = data.event.producers.map(producer => ({
        ...producer,
        translated_role: this.roleTranslation[producer.role],
      }));
      data.event.start_at = moment(data.event.start_at).format('D [de] MMMM [de] YYYY, HH:mm[h]');
      data.event.end_at = moment(data.event.end_at).format('D [de] MMMM [de] YYYY, HH:mm[h]');
      data.event.last_post_date = data.event.last_post_date
        ? moment(data.event.last_post_date).format('D [de] MMMM [de] YYYY, HH:mm[h]')
        : null;

      this.setState({ event: data.event, showAlert: false });
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: [
              'Não foi possível finalizar o evento. Por favor, atualize a página e tente novamente.',
            ],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  addManager = async (e) => {
    e.preventDefault();

    try {
      const { managerEmail } = this.state;
      const formData = new FormData();
      formData.append('manager_email', managerEmail);
      formData.append('event_id', this.props.match.params.id);
      const data = await api.post('event_roles', formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });

      const updatedProducers = data.data.producers;
      this.setState(prevState => ({
        event: {
          ...prevState.event,
          producers: updatedProducers,
        },
      }));
      document.getElementById('closeManagerModal').click();
      this.setState(
        {
          alert: {
            title: 'Gerente adicionado!',
            type: 'success',
            messages: ['Gerente foi adicionado com sucesso.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
          this.setState({
            managerEmail: '',
          });
        },
      );
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: err.response.data.errors,
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  deleteManager = (id) => {
    this.setState(
      {
        alert: {
          title: 'Atenção',
          type: 'warning',
          messages: ['Tem certeza que deseja deletar este gerente?'],
          confirmBtnText: 'Deletar',
          confirmBtnBsStyle: 'danger',
          showCancel: true,
          cancelBtnText: 'Não',
          cancelBtnBsStyle: 'info',
          onConfirm: () => this.confirmDeleteManager(id),
        },
      },
      () => {
        this.openAlert();
      },
    );
  };

  confirmDeleteManager = async (id) => {
    const { event } = this.state;
    try {
      await api.delete(`event_roles/${this.props.match.params.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
        params: {
          producer_id: id,
        },
      });

      this.closeAlert();
      const updatedProducers = event.producers.filter(producer => producer.id !== id);
      this.setState(prevState => ({
        event: {
          ...prevState.event,
          producers: updatedProducers,
        },
      }));
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: ['Não foi possível deletar o gerente. Por favor, atualize a página.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  render() {
    const {
      active_promoters,
      address,
      approval_status,
      benefits,
      cover,
      end_at,
      extra,
      finishable,
      last_post_date,
      min_followers,
      name,
      place,
      producers,
      rules,
      segment,
      slots,
      start_at,
      status,
      whatsapp_link,
    } = this.state.event;

    const {
      alert: {
        cancelBtnText,
        cancelBtnBsStyle,
        confirmBtnText,
        confirmBtnBsStyle,
        messages,
        onConfirm,
        showCancel,
        title,
        type,
      },
      loading,
      managerEmail,
      showAlert,
    } = this.state;

    const eventId = this.props.match.params.id;

    return (
      <Fragment>
        {loading ? (
          <Loading />
        ) : (
          <Fragment>
            <div className="row">
              <div className="col-12">
                {status !== 'active' && <h2>Evento finalizado</h2>}
                {approval_status === 'pending' && <h2>Evento pendente</h2>}
                {approval_status === 'rejected' && <h2>Evento rejeitado</h2>}
                {approval_status === 'approved' && (
                  <ButtonPanel>
                    {status === 'active' && (
                      <Link to={`/panel/events/${eventId}/edit`} className="btn btn-success">
                        Editar evento
                      </Link>
                    )}
                    {status === 'active' ? (
                      <Link to={`/panel/events/${eventId}/promoters`} className="btn btn-primary">
                        Divulgadores
                      </Link>
                    ) : (
                      <Link to={`/panel/events/${eventId}/evaluate`} className="btn btn-primary">
                        Divulgadores
                      </Link>
                    )}
                    {status === 'active' ? (
                      <DropdownButton
                        title="Publicações"
                        options={[
                          { text: 'Publicações do evento', path: `/panel/events/${eventId}/posts` },
                          {
                            text: 'Criar publicação',
                            path: `/panel/create-post?event_id=${eventId}`,
                          },
                        ]}
                      />
                    ) : (
                      <Link to={`/panel/events/${eventId}/posts`} className="btn btn-primary">
                        Publicações
                      </Link>
                    )}
                    {status === 'active' && approval_status === 'approved' && (
                      <div className="end-buttons align-right">
                        {/* <Button onClick={() => this.deleteEvent(eventId)} className="btn-danger">
                          Deletar evento
                        </Button> */}
                        {finishable && (
                          <Button onClick={() => this.finishEvent(eventId)} className="btn-warning">
                            Finalizar evento
                          </Button>
                        )}
                      </div>
                    )}
                  </ButtonPanel>
                )}
              </div>
            </div>
            <div className="box">
              <div className="row">
                <div className="col-12">
                  <div className="card card-big">
                    {cover && (
                      <div
                        className="card-image"
                        style={{
                          backgroundImage: `url(${cover})`,
                        }}
                      />
                    )}
                    <div className="card-block">
                      <h4 className="card-title">{name}</h4>
                      {address && (
                        <p className="card-text">
                          <FontAwesomeIcon icon={faMapMarkerAlt} />{' '}
                          <a
                            href={`https://www.google.com/maps/search/${address}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {place || address}
                          </a>
                        </p>
                      )}
                      <p className="card-text">
                        <FontAwesomeIcon icon={faCalendarAlt} /> {start_at} - {end_at}
                      </p>
                      <p className="card-text">
                        {last_post_date ? (
                          <Fragment>
                            <strong>Última publicação: </strong>
                            {last_post_date}
                          </Fragment>
                        ) : (
                          'Não tem publicações'
                        )}
                      </p>
                      <p className="card-text">
                        <strong>Divulgadores ativos:</strong> {active_promoters}
                      </p>
                      {benefits && (
                        <p className="card-text">
                          <strong>Benefícios:</strong> {benefits}
                        </p>
                      )}
                      {whatsapp_link && (
                        <p className="card-text">
                          <strong>Grupo no Whatsapp:</strong>{' '}
                          <a
                            href={`http://${whatsapp_link}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {whatsapp_link}
                          </a>
                        </p>
                      )}
                      {extra && (
                        <p className="card-text">
                          <strong>Mais informações:</strong> {extra}
                        </p>
                      )}
                      {rules && (
                        <p className="card-text">
                          <strong>Regras:</strong> {rules}
                        </p>
                      )}
                      <p className="card-text">
                        <strong>Vagas:</strong> {slots}
                      </p>
                      <p className="card-text">
                        <strong>Mínimo de seguidores:</strong> {min_followers}
                      </p>
                      {segment && (
                        <p className="card-text">
                          <strong>Segmento:</strong> {segment.name}
                        </p>
                      )}

                      <section>
                        <h5 className="section-title">Gerentes</h5>
                        <ManagerList>
                          {producers
                            && producers.map(manager => (
                              <li key={manager.id}>
                                <strong>{manager.name}</strong> -{' '}
                                {this.roleTranslation[manager.role]}
                                {status === 'active' && manager.deletable && (
                                  <button
                                    type="button"
                                    onClick={() => this.deleteManager(manager.id)}
                                    className="delete-manager"
                                  >
                                    <FontAwesomeIcon icon={faTrashAlt} />
                                  </button>
                                )}
                              </li>
                            ))}
                        </ManagerList>
                        {status === 'active' && (
                          <button
                            type="button"
                            onClick={this.handleManagerModal}
                            className="btn btn-link"
                            data-toggle="modal"
                            data-target="#addManager"
                          >
                            Adicionar gerente
                          </button>
                        )}
                      </section>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {showAlert && (
              <SweetAlert
                type={type}
                confirmBtnText={confirmBtnText}
                confirmBtnBsStyle={confirmBtnBsStyle}
                showCancel={showCancel}
                cancelBtnText={cancelBtnText}
                cancelBtnBsStyle={cancelBtnBsStyle}
                title={title}
                onConfirm={onConfirm}
                onCancel={this.closeAlert}
              >
                <ul>
                  {messages.map(msg => (
                    <li key={msg}>{msg}</li>
                  ))}
                </ul>
              </SweetAlert>
            )}

            <div
              className="modal fade"
              id="addManager"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="addManagerLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="addManagerLabel">
                      Adicionar gerente
                    </h5>
                    <button
                      id="closeManagerModal"
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <form onSubmit={this.addManager}>
                      <div className="input-group">
                        <Input
                          type="email"
                          onChange={this.handleChange}
                          value={managerEmail}
                          name="managerEmail"
                          className="form-control"
                          placeholder="Email do gerente"
                        />
                        <div className="input-group-append">
                          <button className="btn btn-primary" type="submit">
                            Convidar
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </Fragment>
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/EventDetail/index.js